import {
    Box,
    CrudMode,
    DataDisplay,
    Grid,
    pn,
    Stack,
    Typography,
    useElementBreakpoints,
    ValidationErrors,
} from "@compass/core";
import { Input } from "components";
import { ScholarshipType, ScholarshipTypeEditResource, ScholarshipTypeViewResource } from "generated/openApi";
import produce from "immer";
import React from "react";

export const ScholarshipTypePageBody = (props: {
    crudMode: CrudMode;
    scholarshipType: ScholarshipType;
    setScholarshipType: (value: ScholarshipType) => void;
    viewResource: ScholarshipTypeViewResource;
    editResource: ScholarshipTypeEditResource;
    validationErrors: ValidationErrors;
}) => {
    const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints } = useElementBreakpoints();
    const properties = props.viewResource.properties || [];

    const nameField = () => {
        const propertyName = pn<ScholarshipType>("name");
        const property = properties.find((x) => x.propertyName === propertyName);

        return props.crudMode === "view" ? (
            <DataDisplay label={property?.displayName}>{props.scholarshipType.name}</DataDisplay>
        ) : (
            <Input
                modelProperty={property}
                errors={props.validationErrors[propertyName]}
                value={props.scholarshipType.name}
                onChange={(e) =>
                    props.setScholarshipType(
                        produce(props.scholarshipType, (draft) => {
                            draft.name = e.target.value;
                        })
                    )
                }
            />
        );
    };

    return (
        <Grid ref={breakpointsRef} container spacing="sm">
            <Grid item xs={largeFieldBreakpoints}>
                {nameField()}
            </Grid>
        </Grid>
    );
};